export class DeviceDeskIcon {
    public deskId: number;
    public imgPath: string;

    constructor(deskId: number, imgPath: string) {
        this.deskId = deskId;
        this.imgPath = imgPath;
    }
}